export const TRANSACTION_CHANNEL = "TransactionChannel";

export const TRANSACTION_CREATED = "createTransaction";
export const TRANSACTION_UPDATED = "updateTransaction";

export const ACCESS_PROVISION_BEGAN = "accessProvisioningBegan";
export const ACCESS_PROVISION_SUCCESS = "accessProvisioningSuccess";
export const ACCESS_PROVISION_FAILED = "accessProvisioningFailed";

export const channelNamesMap = {
	notificationEvents: [
		TRANSACTION_CREATED,
		TRANSACTION_UPDATED,
		ACCESS_PROVISION_BEGAN,
		ACCESS_PROVISION_SUCCESS,
		ACCESS_PROVISION_FAILED,
	],
};
